import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledModalFooter = styled.div`
  position: relative;
  text-align: center;
`;

export const StyledModalFooterBar = styled.div`
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  width: 100%;
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
  padding: 11px 16px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;
